import React, {useMemo, useState} from 'react'
import {makeStyles, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import DeleteIcon from '@material-ui/icons/Delete'
import Tr from 'translations/Translations';
import {withRouter} from "react-router";
import DemandService from 'services/DemandService';
import {connect} from 'react-redux'
import RouterPath from 'libs/RouterPath';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import InfoBarTitleButton from './InfoBarTitleButton';
import extendFindSectionEditable from 'libs/extendFindSectionEditable';
import Confirm from "components/popup/confirm/Confirm";
import {isDemandModification, isDemandOfferCollection, isDemandPreparing, wasEverPublished, isDemandOfferEvaluation} from "libs/getDemandStatus";
import InvalidateDemandPopup from "components/popup/invalidate/InvalidateDemandPopup";
import RfxRoundService from "services/RfxRoundService";
import StatisticsService from "services/StatisticsService";
import LoadingScreen from "components/complex/loadingScreen/LoadingScreen";
import clsx from 'clsx';
import PrivilegeService from "services/PrivilegeService";
import supportedNoApiScreens from "libs/supportedNoApiScreens";

const useStyle = makeStyles(theme => ({
    root: {},
    item: {
        '&:first-child': {
            width: 'calc(100% - 300px)'
        },
        '&:nth-child(2)': {
            width: 'calc(100% - 300px)'
        }
    },
    title: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    titleWrapped: {
        whiteSpace: 'nowrap'
    },
    label: {
        fontWeight: theme.typography.fontWeightBold
    }
}));

function InfoBarTitle(
    {
        contractor,
        title,
        number,
        attach,
        demandValidation = [],
        match,
        stepperState,
        steps,
        ojsPublicationStatus = {},
        demandHeader,
        isDemandChanged = {},
        rfxPrivileges = {},
        demandPrivileges = {}
    }) {
    const classes = useStyle();
    const [openDelete, setOpenDelete] = useState(false)
    const [openInvalidate, setOpenInvalidate] = useState(false)
    const [openClose, setOpenClose] = useState(false)
    const [working, setWorking] = useState(false)
    const id = match.params.id;

    const editable = extendFindSectionEditable(demandValidation, steps, stepperState)

    const handleDelete = () => {
        setOpenDelete(false);
        setWorking(true);
        DemandService.deleteDemand(id).then(() => {
                RouterPath.redirect(RouterPath.MY_PROCEDURE);
            }
        ).catch(()=> setWorking(false))
    }

    const isModification = isDemandModification() === true;
    const isPreparing = isDemandPreparing() === true;
    const isOfferCollection = isDemandOfferCollection() === true;
    const isOfferEvaluation = isDemandOfferEvaluation() === true;

    const rp = RouterPath.myProcedure;

    const handleCancel = () => {
        setOpenInvalidate(true);
    }

    const handleClose = () => {
        setOpenClose(true);
    }

    const isPublished = wasEverPublished();

    // eslint-disable-next-line
    const isDeleteActive = useMemo(() => !isPublished && isPreparing, [demandValidation, demandHeader]);
    // eslint-disable-next-line
    const isInvalidationActive = useMemo(() => isPreparing || isModification || isOfferCollection, [demandValidation, demandHeader])
    // eslint-disable-next-line
    const isCloseActive = useMemo(() => isOfferCollection || isOfferEvaluation, [demandValidation, demandHeader]);

    const onInvalidate = (({comment}) => {
        setOpenInvalidate(false);
        setWorking(true);
        StatisticsService.getCurrentRound(id).then((resp) => {
            RfxRoundService.cancelRound(resp.id, comment)
                .then(() => {
                    RouterPath.redirect(RouterPath.createPath(rp.steps.MP_4_ID, {id}))
                }).catch(() => setWorking(false))
        })
    })

    const onClose = (({comment}) => {
        setOpenClose(false);
        setWorking(true);
        StatisticsService.getCurrentRound(id).then((resp) => {
            RfxRoundService.closeRound(resp.id, comment)
                .then(() => {
                    RouterPath.redirect(RouterPath.createPath(rp.steps.MP_4_ID, {id}))
                }).catch(() => setWorking(false))
        })
    })

    return (
        <>
            <GridBlock alignItems='center' justify='space-between' gridClasses={{root: classes.root, item: classes.item}}>
                <Typography variant='h6' className={clsx(classes.title, {[classes.titleWrapped]: !attach})}>
                    <b>{Tr('name')}:{' '}</b>{title}
                </Typography>
                <Typography variant='body1' className={clsx(classes.title, {[classes.titleWrapped]: !attach})}>
                    <b>{Tr('number_of_processing')}:{' '}</b>{number}
                </Typography>
                {(!contractor && !supportedNoApiScreens()) && <GridBlock>
                    {(editable && isDeleteActive) && <InfoBarTitleButton
                        Icon={DeleteIcon}
                        label={Tr('delete')}
                        onClick={() => setOpenDelete(true)}
                    />}

                    {editable && isPublished && isInvalidationActive &&
                        <InfoBarTitleButton
                            Icon={CancelOutlinedIcon}
                            label={Tr('invalidate')}
                            onClick={handleCancel}
                            disabled={!rfxPrivileges.CANCEL || isModification}
                        />
                    }

                    {editable && isPublished && isCloseActive &&
                    <InfoBarTitleButton
                        Icon={CancelOutlinedIcon}
                        label={Tr('close')}
                        onClick={handleClose}
                        disabled={!demandPrivileges.CLOSE || isModification}
                    />
                    }
                </GridBlock>}
            </GridBlock>
            <Confirm
                open={openDelete}
                onConfirm={handleDelete}
                onCancel={() => setOpenDelete(false)}
                confirmText="delete_popup_text1"
                confirmText2="delete_popup_text2"
            />
            <InvalidateDemandPopup onClose={() => setOpenInvalidate(false)} open={openInvalidate} onSubmit={onInvalidate}/>
            <InvalidateDemandPopup onClose={() => setOpenClose(false)} open={openClose} onSubmit={onClose} title={'close'} type={'closeDemand'}/>
            {working ? <LoadingScreen/> : ''}
        </>
    )

}

InfoBarTitle.propTypes = {
    classes: PropTypes.any,
    contractor: PropTypes.bool.isRequired
}


export default connect((state) => ({
    demandValidation: state.resources.demandValidation,
    isDemandChanged: state.resources.isDemandChanged,
    ojsPublicationStatus: state.resources.ojsPublicationStatus,
    stepperState: state.stepper.state,
    steps: state.stepper.steps[0].steps,
    demandHeader: state.resources.demandHeader,
    rfxPrivileges: state.privileges[PrivilegeService.RFX_PRIVILEGE_STORE_KEY],
    demandPrivileges: state.privileges[PrivilegeService.DEMAND_PRIVILEGE_STORE_KEY],
}), {})(withRouter(InfoBarTitle));
